import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { formatMessage } from "devextreme/localization";
import { CalculatorSummaryComponent } from "./calculator-components/calculator-summary/calculator-summary.component";
import { CalculatorPrepressComponent } from "./calculator-components/calculator-prepress/calculator-prepress.component";
import {
  CalculationTableConfig,
  CalculatorUsPdfRequest,
} from "../calculator-us/calculator-us-formData";
import {
  PdfQuoteNumber,
  UsCalculatorResult,
} from "../../../model/calculation/calculationResult";
import {
  CalculatorUsService,
  PaperWeightCalculationData,
} from "../../../services/calculator-us.service";
import { ScrollService } from "../../../services/scroll.service";
import { environment } from "../../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { ScalerService } from "../../../services/scaler.service";
import { CalculatorJobSpecificationComponent } from "./calculator-components/calculator-job-specification/calculator-job-specification.component";
import { CalculatorPaperSpecificationComponent } from "./calculator-components/calculator-paper-specification/calculator-paper-specification.component";
import { CalculatorCasetypeSpecificationComponent } from "./calculator-components/calculator-casetype-specification/calculator-casetype-specification.component";
import { CalculatorComponentSpecificationComponent } from "./calculator-components/calculator-component-specification/calculator-component-specification.component";
import { CalculatorBinderyComponent } from "./calculator-components/calculator-bindery/calculator-bindery.component";
import { JobSpecification } from "../../../model/calculator-us-remastered/jobSpecification";
import { GeneralInformation } from "../../../model/calculator-us-remastered/generalInformation";
import { CaseTypeSpecification } from "../../../model/calculator-us-remastered/caseTypeSpecification";
import { PaperSpecification } from "../../../model/calculator-us-remastered/paperSpecification";
import { ComponentSpecification } from "../../../model/calculator-us-remastered/componentSpecification";
import { PrePressSpecification } from "../../../model/calculator-us-remastered/prePressSpecification";
import { BinderySpecification } from "../../../model/calculator-us-remastered/binderySpecification";
import { SummaryItem } from "../../../model/calculator-us-remastered/summaryItem";
import { Subscription } from "rxjs";

@Component({
  selector: "app-calculator-us-remastered",
  templateUrl: "./calculator-us-remastered.component.html",
  styleUrls: ["./calculator-us-remastered.component.scss"],
})
export class CalculatorUsRemasteredComponent implements OnInit, OnDestroy {
  @ViewChild("summaryComponent") summaryComponent?: CalculatorSummaryComponent;
  @ViewChild("jobSpecificationComponent")
  jobSpecificationComponent: CalculatorJobSpecificationComponent;
  @ViewChild("paperSpecificationComponent")
  paperSpecificationComponent: CalculatorPaperSpecificationComponent;
  @ViewChild("caseTypeSpecificationComponent")
  caseTypeComponent: CalculatorCasetypeSpecificationComponent;
  @ViewChild("componentSpecificationComponent")
  componentSpecificationComponent: CalculatorComponentSpecificationComponent;
  @ViewChild("prePressComponent")
  prePressComponent: CalculatorPrepressComponent;
  @ViewChild("binderyComponent") binderyComponent: CalculatorBinderyComponent;

  constructor(
    private calculatorUsService: CalculatorUsService,
    private scroll: ScrollService,
    private http: HttpClient,
    private scalerService: ScalerService
  ) {}

  calculationDrawerOpened: boolean = false;
  calculateButtonType: string = "default";
  calculateButtonStylingMode: string = "contained";

  generalInformation = new GeneralInformation();
  jobSpecification = new JobSpecification();
  paperSpecification = new PaperSpecification();
  caseTypeSpecification = new CaseTypeSpecification();
  calculatorComponents = new ComponentSpecification();
  prePressSpecification = new PrePressSpecification();
  binderySpecification = new BinderySpecification();

  selectedProductClassification: string = "";

  selectedInitialReprint: string = "";

  // Printed Endsheet Status für Paper Specification
  printedEndsheetActive: boolean = false;

  // Prepress toggle state
  prepressEnabled: boolean = false;

  // Summary arrays für dynamische Übersicht
  private currentPaperSpecSummaryItems: SummaryItem[] = [];
  private currentCaseTypeSummaryItems: SummaryItem[] = [];
  private currentComponentSummaryItems: SummaryItem[] = [];
  private currentPrepressSummaryItems: SummaryItem[] = [];
  private currentBinderySummaryItems: SummaryItem[] = [];

  currentSummaryItems: SummaryItem[] = [];

  calculationResponse: UsCalculatorResult;
  calculationTableConfig: CalculationTableConfig = new CalculationTableConfig(
    false,
    false,
    false
  );
  quantities: number[];
  responseAncillaryGroupTypes: any;

  scalerLabelUrl = `${environment.scalerLabelUrl}`;

  showToast = false;
  toastMessage = "For some reason we need an initial value here...";
  toastDisplayTime: number = 4000;

  paperWeightData: PaperWeightCalculationData | null = null;
  private paperWeightSubscription?: Subscription;

  ngOnDestroy() {
    this.scroll.scrollViewInstance.option("disabled", false);
    if (this.paperWeightSubscription) {
      this.paperWeightSubscription.unsubscribe();
    }
  }

  ngOnInit(): void {
    console.log("📊 MAIN - ngOnInit started");

    // Subscribe to paper weight calculations
    this.paperWeightSubscription =
      this.calculatorUsService.paperWeightCalculation$.subscribe(
        (data: PaperWeightCalculationData) => {
          this.paperWeightData = data;
        }
      );
  }

  formatMessage = formatMessage;

  generalInformationChanged(generalInformation: [GeneralInformation, boolean]) {
    console.log(
      `🎯 General Information value changed to: `,
      generalInformation
    );
    // Publisher changed event
    if (generalInformation[1]) {
      this.resetFormValues();
      this.resetOverviewValues();
    }

    this.generalInformation = generalInformation[0];
  }

  jobSpecificationChanged(jobSpecification: JobSpecification) {
    console.log(`🎯 Jop Specification value changed to: `, jobSpecification);
    this.jobSpecification = jobSpecification;
    if (jobSpecification.product) {
      this.selectedProductClassification = jobSpecification.product;
    }
    if (jobSpecification.initialReprint) {
      this.selectedInitialReprint = jobSpecification.initialReprint;
    }
  }

  paperSpecificationChanged(paperSpecification: PaperSpecification) {
    this.paperSpecification = paperSpecification;
  }

  caseTypeSpecificationChanged(caseTypeSpecification: CaseTypeSpecification) {
    this.caseTypeSpecification = caseTypeSpecification;
  }

  calculatorComponentsChanged(componentSpecification: ComponentSpecification) {
    this.calculatorComponents = componentSpecification;
  }

  prePressSpecificationChanged(prePressSpecification: PrePressSpecification) {
    this.prePressSpecification = prePressSpecification;
  }

  binderySpecificationChanged(binderySpecification: BinderySpecification) {
    this.binderySpecification = binderySpecification;
  }

  public hasPublisherSelected(): boolean {
    return !!this.generalInformation.publisher;
  }

  /**
   * Prüft ob ein Produkt ausgewählt wurde
   */
  public hasProductSelected(): boolean {
    return this.selectedProductClassification != "";
  }

  /**
   * Prüft ob "Initial" ausgewählt wurde (für Prepress-Anzeige)
   */
  public isInitialSelected(): boolean {
    return this.selectedInitialReprint?.toUpperCase().includes("INITIAL");
  }

  /**
   * Prüft ob Prepress angezeigt werden soll (Initial ausgewählt ODER manuell aktiviert)
   */
  public shouldShowPrepress(): boolean {
    return (
      this.hasProductSelected() &&
      (this.isInitialSelected() || this.prepressEnabled)
    );
  }

  /**
   * Toggle-Methode für Prepress-Aktivierung
   */
  public togglePrepress(): void {
    this.prepressEnabled = !this.prepressEnabled;
    console.log(
      "🔄 Prepress toggled:",
      this.prepressEnabled ? "Enabled" : "Disabled"
    );
  }

  public addToPaperSpecSummary(items: SummaryItem[]): void {
    this.currentPaperSpecSummaryItems = items;
    this.updateCurrentSummaryItems();
  }
  public addToCaseTypeSummary(items: SummaryItem[]): void {
    this.currentCaseTypeSummaryItems = items;
    this.updateCurrentSummaryItems();
  }
  public addToComponentSummary(items: SummaryItem[]): void {
    this.currentComponentSummaryItems = items;
    this.updateCurrentSummaryItems();
  }
  public addToPrepressSummary(items: SummaryItem[]): void {
    this.currentPrepressSummaryItems = items;
    this.updateCurrentSummaryItems();
  }
  public addToBinderySummary(items: SummaryItem[]): void {
    this.currentBinderySummaryItems = items;
    this.updateCurrentSummaryItems();
  }

  private updateCurrentSummaryItems() {
    this.currentSummaryItems = [
      ...this.currentPaperSpecSummaryItems,
      ...this.currentCaseTypeSummaryItems,
      ...this.currentComponentSummaryItems,
      ...this.currentPrepressSummaryItems,
      ...this.currentBinderySummaryItems,
    ];
  }

  /**
   * Event-Handler für Printed Endsheet Status Change
   */
  public onPrintedEndsheetStatusChange(isActive: boolean): void {
    console.log("📋 MAIN: Printed Endsheet status changed to:", isActive);
    this.printedEndsheetActive = isActive;
  }

  private prepareResponseTable(data: UsCalculatorResult) {
    let calcData = data.data;
    this.calculationTableConfig.responseSuccessful = true;
    console.log("prepareResponseTable response set to true.");

    this.responseAncillaryGroupTypes = data.data.ancillaryItemGroupList[0]
      .ancillaryItemList!.filter(
        (ancillaryItem) =>
          ancillaryItem.invoiceItemAncillaryType == "SUMMARY" &&
          ancillaryItem.invoiceItemAncillaryCode != "SUMMARY_TOTAL"
      )
      .map((value) => {
        return value.ancillaryTypeName == "OPTION_GROUP"
          ? { value: value.ancillaryTypeName, name: value.ancillaryCodeName }
          : {
              value: value.ancillaryTypeName,
              name: formatMessage(
                "calculator.calculation.us.response.headLineText." +
                  value.ancillaryTypeName.toLowerCase()
              ),
            };
      });

    // Überprüfung für das zweite Objekt in ancillaryItemGroupList
    this.calculationTableConfig.showSecondCol = !!(
      calcData.ancillaryItemGroupList &&
      calcData.ancillaryItemGroupList[1] &&
      calcData.ancillaryItemGroupList[1].ancillaryItemList &&
      calcData.ancillaryItemGroupList[1].ancillaryItemList.length > 0
    );

    // Überprüfung für das dritte Objekt in ancillaryItemGroupList
    this.calculationTableConfig.showThirdCol = !!(
      calcData.ancillaryItemGroupList &&
      calcData.ancillaryItemGroupList[2] &&
      calcData.ancillaryItemGroupList[2].ancillaryItemList &&
      calcData.ancillaryItemGroupList[2].ancillaryItemList.length > 0
    );
  }

  public isSelectedProductWithComponents(): boolean {
    return !this.selectedProductClassification.includes("WITHOUT");
  }

  public calculate(e: any) {
    function changeButtonProperties(
      b: boolean,
      that: CalculatorUsRemasteredComponent
    ) {
      if (b) {
        e.component.instance().option("text", "Close and edit details");
        e.component.instance().option("icon", "close");
        that.calculateButtonType = "normal";
        that.calculateButtonStylingMode = "text";
      } else {
        e.component.instance().option("text", "Calculate");
        e.component.instance().option("icon", "");
        that.calculateButtonType = "default";
        that.calculateButtonStylingMode = "contained";
      }
    }

    // Open Drawer
    if (!this.calculationDrawerOpened) {
      this.calculationResponse = <UsCalculatorResult>{};
      try {
        this.calculatorUsService
          .calculateUs(
            this.jobSpecification,
            this.generalInformation,
            this.calculatorComponents,
            this.paperSpecification,
            this.caseTypeSpecification,
            this.binderySpecification
          )
          .then((data: UsCalculatorResult) => {
            changeButtonProperties(true, this);

            this.calculationResponse = data;
            this.prepareResponseTable(data);

            // Quantity Array for the table headline
            this.quantities = [
              this.jobSpecification.quantity1,
              this.jobSpecification.quantity2,
              this.jobSpecification.quantity3,
            ]
              .map(Number)
              .filter((q) => q !== 0);
          })
          .catch((e) => {
            console.error("Error during calculation:", e);
            const errorMessage =
              e?.error?.message ||
              e?.message ||
              String(e) ||
              "An unknown error occurred";
            this.handleCalculationError(errorMessage);
          })
          .finally(() => {
            if (
              this.calculationResponse &&
              this.calculationResponse.data &&
              this.responseAncillaryGroupTypes
            ) {
              document
                .querySelector("#formButtonsContainer")
                ?.classList.toggle("heightAuto");

              this.calculationDrawerOpened = !this.calculationDrawerOpened;

              // dxScrollView prevents drawer from scrolling - so we disable it 😎
              this.scroll.scrollViewInstance.option("disabled", true);
            }
          });
      } catch (e) {
        console.error("Error during calculation:", e);
        const errorMessage =
          e?.error?.message ||
          e?.message ||
          String(e) ||
          "An unknown error occurred";
        this.handleCalculationError(errorMessage);

        this.quantities = [];
        this.calculationTableConfig = new CalculationTableConfig(
          false,
          false,
          false
        );
      }
    }
    // Close Drawer
    else {
      // Match CSS transition duration
      setTimeout(() => {
        changeButtonProperties(false, this);

        this.calculationDrawerOpened = !this.calculationDrawerOpened;

        // Enable scroll-ability after drawer is closed
        this.scroll.scrollViewInstance.option("disabled", false);
      }, 400);

      // Toggle CSS with JS instead of Angular to allow smooth height transition
      document
        .querySelector("#formButtonsContainer")
        ?.classList.toggle("heightAuto");
    }
  }

  private handleCalculationError(message: string) {
    this.toastMessage = message;
    this.showToast = true;
    this.toastDisplayTime = 5000;
  }

  async downloadPdf() {
    // calculate before download
    try {
      // Send request to /api/reports/us-calculation endpoint to download PDF
      let request = await this.preparePdfRequestData();
      this.scalerService.downloadUsCalculatorPdf(
        "calculation",
        JSON.stringify(request)
      );
    } catch (error) {
      console.error("Error during PDF download:", error);
      this.handleCalculationError("PDF download failed. Please try again.");
    }
  }

  private async preparePdfRequestData(): Promise<CalculatorUsPdfRequest> {
    const quoteNumber: string = await this.getQuoteNumber();

    let pdfRequestData: CalculatorUsPdfRequest = {
      ...this.calculationResponse,
      language: "en",
      labelUrl: this.scalerLabelUrl,
      pdfFooterLine1: formatMessage("calculator.pdf.general.pdfFooterLine1"),
      pdfFooterLine2: formatMessage("calculator.pdf.general.pdfFooterLine2"),
      pdfVersion: formatMessage("calculator.pdf.general.pdfVersion"),
      generalInformation: {
        author: this.jobSpecification.author,
        customer: this.generalInformation.publisher?.displayName || "",
        customerContact: this.generalInformation.customerContact,
        date: new Date().toLocaleDateString("en-US"),
        quoteNumber: quoteNumber,
        bpgContact: this.generalInformation.bpgContact,
        bpgEmail: formatMessage(
          "calculator.pdf.generalInformation.bpgEmailValue"
        ),
      },
      jobSpecification: <any>{
        title: this.jobSpecification.title,
        quantity: Object.values(this.quantities).map(Number),
        trimSize:
          this.jobSpecification.width + " x " + this.jobSpecification.height,
        pages: this.jobSpecification.pages || "0",
        //prep: this.jobSpecification.prep, //
        //proofs: this.jobSpecification.proofText, //
        //plates: this.jobSpecification.plates, //
        //paper: this.jobSpecification.paperText,
        //print: this.jobSpecification.printText, //
        //bind: this.jobSpecification.bind, //
        //pack: this.selectedCartonPack.replace(
        //  formatMessage("calculator.pdf.general.selectedCartonPack.value"),
        //  formatMessage(
        //    "calculator.pdf.general.selectedCartonPack.replaceValue"
        //  )
        //),
      },
    };

    return pdfRequestData;
  }

  private async getQuoteNumber(): Promise<string> {
    const quoteNumberWrapper = await this.http
      .get<PdfQuoteNumber>(
        `${environment.baseUrl}/api/calculator/us/quote-number`
      )
      .toPromise();
    return quoteNumberWrapper.quoteNumber;
  }

  resetOverviewValues() {
    this.currentPaperSpecSummaryItems = [];
    this.currentCaseTypeSummaryItems = [];
    this.currentComponentSummaryItems = [];
    this.currentPrepressSummaryItems = [];
    this.currentBinderySummaryItems = [];

    if (this.summaryComponent) {
      this.summaryComponent.hasInitializedProductValues = false;
    }
  }

  resetFormValues() {
    if (this.jobSpecificationComponent?.jobForm != undefined)
      this.jobSpecificationComponent.jobForm.instance.resetValues();

    if (this.paperSpecificationComponent?.paperForm != undefined)
      this.paperSpecificationComponent.paperForm.instance.resetValues();

    if (this.caseTypeComponent?.caseTypeForm != undefined)
      this.caseTypeComponent.caseTypeForm.instance.resetValues();

    if (this.componentSpecificationComponent?.jacketForm != undefined)
      this.componentSpecificationComponent.jacketForm.instance.resetValues();

    if (this.componentSpecificationComponent?.endsheetForm != undefined)
      this.componentSpecificationComponent.endsheetForm.instance.resetValues();

    if (this.prePressComponent?.prePressForm != undefined)
      this.prePressComponent.prePressForm.instance.resetValues();

    if (this.binderyComponent?.binderyForm != undefined)
      this.binderyComponent.binderyForm.instance.resetValues();

    this.jobSpecificationComponent.initializeFieldItems();
    this.paperSpecificationComponent.resetFieldItems();
    this.caseTypeComponent.resetFieldItems();
    this.prePressComponent.resetFieldItems(true);
    this.binderyComponent.resetFieldItems();

    this.jobSpecification = new JobSpecification();
    this.paperSpecification = new PaperSpecification();
    this.caseTypeSpecification = new CaseTypeSpecification();
    this.calculatorComponents = new ComponentSpecification();
    this.prePressSpecification = new PrePressSpecification();
    this.binderySpecification = new BinderySpecification();

    setTimeout(() => {
      this.selectedProductClassification = "";
    }, 0);
  }
}
